<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div id="seleccionarEsCliente">
        <h2>¿Es cliente de DIRECTV?</h2>
        <div>
          <a @click.prevent="save">
            <div>
              <p>Si</p>
            </div>
          </a>
          <a @click.prevent="save">
            <div>
              <p>No</p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
  </div>
</template>

<script>

export default {
  data () {
    return {
      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }

      this.evento = this.$store.getters['eventos/evento'];
      if (this.evento) {
        this.eventoNombre = this.evento.nombre;
      }
      if (!this.evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  methods: {
    save (event) {
      var esCliente = false;
      
      if (event) {
        esCliente = (event.target.innerHTML.trim().toLowerCase() == 'si') ? true : false;
      }

      this.$store.dispatch('participante/setEsClienteParticipante', esCliente)
        .then(() => this.$router.push({ name: 'IngresoCelularTeclado' }))
        .catch( error => {
          this.error = true;
          this.errorMessage = error;
        });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoEsCliente.vue